import React from 'react';
import Assets from '../components/Assets/Assets';

const AssetsPage = () => {
  return <div><Assets /></div>; 
};

export default AssetsPage;
